import { render } from "./PageCheckout.vue?vue&type=template&id=f5522d7c"
import script from "./PageCheckout.js?vue&type=script&lang=js"
export * from "./PageCheckout.js?vue&type=script&lang=js"

import "./PageCheckout.scss?vue&type=style&index=0&lang=scss"
/* custom blocks */
import block0 from "./PageCheckout.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FPageCheckout%2FPageCheckout.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__